/**
 * Where we initialize the database that stores all the levels.
 * We use this locally to load the levels, and edit them.
 */
import PouchDB from "pouchdb";

export class Database {
  public db: PouchDB.Database;
  constructor() {
    this.db = new PouchDB("sokobang");
  }

  async setLevel(
    _id: string,
    entities: any,
    displayName: string
  ): Promise<PouchDB.Core.Response> {
    const doc = await this.db.get(_id);
    if (!doc || !doc._rev) {
      throw new Error("Need to create level first");
    }

    return this.db.put({
      _id,
      entities,
      displayName,
      _rev: doc._rev,
    });
  }

  async fetchAllDocs() {
    return await this.db.allDocs({ include_docs: true, attachments: true });
  }

  async destroyLocalDB() {
    return this.db.destroy().then(function () {
      location.reload();
    });
  }

  async createNewLevel(_id: string): Promise<PouchDB.Core.Response> {
    return this.db.put({
      _id,
      entities: [],
    });
  }

  async getLevel(_id: string) {
    return this.db.get(_id);
  }
}

export const DatabaseHandle = new Database();

window.db = DatabaseHandle;
